'use client'

import { kitchenTerms } from '@/features/kitchen/kitchenTerms'
import { useKitchenSyncStatus } from '@/shared/sync/useKitchenSyncStatus'

export function SyncStatusIndicator() {
  const { online, pendingCount, isFlushing, flush } = useKitchenSyncStatus()

  const dotClass = online ? 'bg-status-success' : 'bg-status-danger'
  const label = !online
    ? kitchenTerms.sync.offline
    : pendingCount > 0
      ? kitchenTerms.sync.pending(pendingCount)
      : kitchenTerms.sync.online

  return (
    <button
      type="button"
      onClick={() => {
        if (online && pendingCount > 0) void flush()
      }}
      disabled={!online || pendingCount === 0 || isFlushing}
      className="flex items-center gap-1.5 max-w-[140px] text-left disabled:cursor-default"
      title={
        pendingCount > 0 && online
          ? 'Ketuk untuk coba sinkronkan ulang'
          : 'Status koneksi tablet dapur'
      }
    >
      <span className={`h-2 w-2 shrink-0 rounded-full ${dotClass}`} aria-hidden />
      <span className="text-caption text-on-surface-variant leading-tight truncate">
        {isFlushing ? 'Menyinkronkan…' : label}
      </span>
    </button>
  )
}
